import request from '@/utils/request';
import { PageResult } from '@/api/typing';

export async function create_address(params: Record<string, any>) {
  return request.post('/cerp/create_address', params);
}

export async function update_address(params: Record<string, any>) {
  return request.post('/cerp/update_address', params);
}

export async function delete_address(params: Record<string, any>) {
  return request.post('/cerp/delete_address', params);
}

export async function recover_address(params: Record<string, any>) {
  return request.post('/cerp/recover_address', params);
}

export async function query_address_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/cerp/query_address_list', params);
}

export async function create_adviser(params: Record<string, any>) {
  return request.post('/cerp/create_adviser', params);
}

export async function update_adviser(params: Record<string, any>) {
  return request.post('/cerp/update_adviser', params);
}

export async function delete_adviser(params: Record<string, any>) {
  return request.post('/cerp/delete_adviser', params);
}

export async function recover_adviser(params: Record<string, any>) {
  return request.post('/cerp/recover_adviser', params);
}

export async function query_adviser_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/cerp/query_adviser_list', params);
}

export async function create_bank_account(params: Record<string, any>) {
  return request.post('/cerp/create_bank_account', params);
}

export async function update_bank_account(params: Record<string, any>) {
  return request.post('/cerp/update_bank_account', params);
}

export async function delete_bank_account(params: Record<string, any>) {
  return request.post('/cerp/delete_bank_account', params);
}

export async function recover_bank_account(params: Record<string, any>) {
  return request.post('/cerp/recover_bank_account', params);
}

export async function query_bank_account_by_select_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/cerp/query_bank_account_by_select_list', params);
}

export async function query_bank_account_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/cerp/query_bank_account_list', params);
}

export async function create_bank_transaction(params: Record<string, any>) {
  return request.post('/cerp/create_bank_transaction', params);
}

export async function update_bank_transaction(params: Record<string, any>) {
  return request.post('/cerp/update_bank_transaction', params);
}

export async function delete_bank_transaction(params: Record<string, any>) {
  return request.post('/cerp/delete_bank_transaction', params);
}

export async function recover_bank_transaction(params: Record<string, any>) {
  return request.post('/cerp/recover_bank_transaction', params);
}

export async function query_bank_transaction_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/cerp/query_bank_transaction_list', params);
}

export async function create_beneficiary(params: Record<string, any>) {
  return request.post('/cerp/create_beneficiary', params);
}

export async function update_beneficiary(params: Record<string, any>) {
  return request.post('/cerp/update_beneficiary', params);
}

export async function delete_beneficiary(params: Record<string, any>) {
  return request.post('/cerp/delete_beneficiary', params);
}

export async function recover_beneficiary(params: Record<string, any>) {
  return request.post('/cerp/recover_beneficiary', params);
}

export async function query_beneficiary_by_select_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/cerp/query_beneficiary_by_select_list', params);
}

export async function query_beneficiary_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/cerp/query_beneficiary_list', params);
}

export async function create_contract(params: Record<string, any>) {
  return request.post('/cerp/create_contract', params);
}

export async function update_contract(params: Record<string, any>) {
  return request.post('/cerp/update_contract', params);
}

export async function delete_contract(params: Record<string, any>) {
  return request.post('/cerp/delete_contract', params);
}

export async function recover_contract(params: Record<string, any>) {
  return request.post('/cerp/recover_contract', params);
}

export async function query_contract_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/cerp/query_contract_list', params);
}

export async function create_custom_field(params: Record<string, any>) {
  return request.post('/cerp/create_custom_field', params);
}

export async function update_custom_field(params: Record<string, any>) {
  return request.post('/cerp/update_custom_field', params);
}

export async function delete_custom_field(params: Record<string, any>) {
  return request.post('/cerp/delete_custom_field', params);
}

export async function recover_custom_field(params: Record<string, any>) {
  return request.post('/cerp/recover_custom_field', params);
}

export async function query_custom_field_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/cerp/query_custom_field_list', params);
}

export async function create_custom_field_set(params: Record<string, any>) {
  return request.post('/cerp/create_custom_field_set', params);
}

export async function update_custom_field_set(params: Record<string, any>) {
  return request.post('/cerp/update_custom_field_set', params);
}

export async function delete_custom_field_set(params: Record<string, any>) {
  return request.post('/cerp/delete_custom_field_set', params);
}

export async function recover_custom_field_set(params: Record<string, any>) {
  return request.post('/cerp/recover_custom_field_set', params);
}

export async function query_custom_field_set_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/cerp/query_custom_field_set_list', params);
}

export async function create_insurance(params: Record<string, any>) {
  return request.post('/cerp/create_insurance', params);
}

export async function update_insurance(params: Record<string, any>) {
  return request.post('/cerp/update_insurance', params);
}

export async function delete_insurance(params: Record<string, any>) {
  return request.post('/cerp/delete_insurance', params);
}

export async function recover_insurance(params: Record<string, any>) {
  return request.post('/cerp/recover_insurance', params);
}

export async function query_insurance_by_select_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/cerp/query_insurance_by_select_list', params);
}

export async function query_insurance_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/cerp/query_insurance_list', params);
}

export async function create_invoice(params: Record<string, any>) {
  return request.post('/cerp/create_invoice', params);
}

export async function update_invoice(params: Record<string, any>) {
  return request.post('/cerp/update_invoice', params);
}

export async function delete_invoice(params: Record<string, any>) {
  return request.post('/cerp/delete_invoice', params);
}

export async function recover_invoice(params: Record<string, any>) {
  return request.post('/cerp/recover_invoice', params);
}

export async function query_invoice_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/cerp/query_invoice_list', params);
}

export async function create_next_of_kin(params: Record<string, any>) {
  return request.post('/cerp/create_next_of_kin', params);
}

export async function update_next_of_kin(params: Record<string, any>) {
  return request.post('/cerp/update_next_of_kin', params);
}

export async function delete_next_of_kin(params: Record<string, any>) {
  return request.post('/cerp/delete_next_of_kin', params);
}

export async function recover_next_of_kin(params: Record<string, any>) {
  return request.post('/cerp/recover_next_of_kin', params);
}

export async function query_next_of_kin_by_select_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/cerp/query_next_of_kin_by_select_list', params);
}

export async function query_next_of_kin_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/cerp/query_next_of_kin_list', params);
}

export async function create_note(params: Record<string, any>) {
  return request.post('/cerp/create_note', params);
}

export async function update_note(params: Record<string, any>) {
  return request.post('/cerp/update_note', params);
}

export async function delete_note(params: Record<string, any>) {
  return request.post('/cerp/delete_note', params);
}

export async function recover_note(params: Record<string, any>) {
  return request.post('/cerp/recover_note', params);
}

export async function query_note_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/cerp/query_note_list', params);
}

export async function create_payslip(params: Record<string, any>) {
  return request.post('/cerp/create_payslip', params);
}

export async function update_payslip(params: Record<string, any>) {
  return request.post('/cerp/update_payslip', params);
}

export async function delete_payslip(params: Record<string, any>) {
  return request.post('/cerp/delete_payslip', params);
}

export async function recover_payslip(params: Record<string, any>) {
  return request.post('/cerp/recover_payslip', params);
}

export async function query_payslip_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/cerp/query_payslip_list', params);
}

export async function create_person_reference_number(params: Record<string, any>) {
  return request.post('/cerp/create_person_reference_number', params);
}

export async function update_person_reference_number(params: Record<string, any>) {
  return request.post('/cerp/update_person_reference_number', params);
}

export async function delete_person_reference_number(params: Record<string, any>) {
  return request.post('/cerp/delete_person_reference_number', params);
}

export async function recover_person_reference_number(params: Record<string, any>) {
  return request.post('/cerp/recover_person_reference_number', params);
}

export async function query_person_reference_number_by_select_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/cerp/query_person_reference_number_by_select_list', params);
}

export async function query_person_reference_number_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/cerp/query_person_reference_number_list', params);
}

export async function create_remittance(params: Record<string, any>) {
  return request.post('/cerp/create_remittance', params);
}

export async function update_remittance(params: Record<string, any>) {
  return request.post('/cerp/update_remittance', params);
}

export async function delete_remittance(params: Record<string, any>) {
  return request.post('/cerp/delete_remittance', params);
}

export async function recover_remittance(params: Record<string, any>) {
  return request.post('/cerp/recover_remittance', params);
}

export async function query_remittance_list(params?: { [key: string]: any }): Promise<PageResult> {
  return request.post('/cerp/query_remittance_list', params);
}

export async function create_remittance_set(params: Record<string, any>) {
  return request.post('/cerp/create_remittance_set', params);
}

export async function update_remittance_set(params: Record<string, any>) {
  return request.post('/cerp/update_remittance_set', params);
}

export async function delete_remittance_set(params: Record<string, any>) {
  return request.post('/cerp/delete_remittance_set', params);
}

export async function recover_remittance_set(params: Record<string, any>) {
  return request.post('/cerp/recover_remittance_set', params);
}

export async function query_remittance_set_list(params?: {
  [key: string]: any;
}): Promise<PageResult> {
  return request.post('/cerp/query_remittance_set_list', params);
}
